import object from 'helpers/object'


export const initialState = {
  cancelList: [],
  isFetching: true,
}

export const setFetching = (state, payload) => (
  object.setIn(state, [ 'isFetching' ], payload)
)

export const setCancelList = (state, payload) => (
  object.setIn(state, [ 'cancelList' ], payload)
)
